<div class="main-chat-box-container" [class.disabled-element]="deletingFile">

  <icbc-upload-files-list mode="full" [class.disabled-element]="generatingMessage"></icbc-upload-files-list>

  <icbc-data-origin-selector [class.disabled-element]="generatingMessage"></icbc-data-origin-selector>

  <div class="main-chat-box-prompt">
    <!-- BOTÓN PARA SUBIR ARCHIVOS -->
    <button class="iese-rounded-button secondary"
            [class.disabled-element]="generatingMessage"
            (click)="uploadFile()">
      <span class="pi pi-paperclip"></span>
    </button>

    <!-- ÁREA DE TEXTO -->
    <textarea class="main-chat-box-input" placeholder="Enter your message..." rows="2"
              [bdcWalkTriggerFor]="popupStep9"
              (keydown)="onKeydown($event)" [(ngModel)]="currentMessage"
              [disabled]="generatingMessage" uidsTextareaAutoresize
              [class.disabled-element]="generatingMessage">
    </textarea>

    <!-- BOTÓN DE MANDAR/PARAR MENSAJE -->
    <button *ngIf="!generatingMessage"
            class="iese-rounded-button primary"
            (click)="sendMessage()">
      <span class="pi pi-send"></span>
    </button>
    <button *ngIf="generatingMessage"
            class="iese-rounded-button primary"
            (click)="stopMessage()">
      <span class="pi pi-stop"></span>
    </button>
  </div>

  <small class="main-chat-box-disclaimer p-2 chat-box-message-color">
    Please keep in mind that ChatGPT can make mistakes, so human supervision is necessary.
  </small>
</div>

<bdc-walk-popup sideNoteText="7/13" [showCloseButton]="false" #popupStep9 name="popupStep9" header="Start using MyAI"
                xPosition="after" yPosition="above" [showButton]="true" buttonText="Next"
                [mustCompleted]="{dialogStep8: true}" class="warning">
  <div>
    Enter your request or query in the text box below and hit 'Enter' to submit MyAI is here to help.
  </div>
  <div class="buttons-skip">
    <button class="iese-button iese-button-skip" (click)="this.bdcWalkService.setTaskCompleted('dialogStep8', false)"
            mat-raised-button color="primary">Previous
    </button>
    <button class="iese-button iese-button-skip" (click)="endOnboardingTour()" mat-raised-button color="primary">Skip
    </button>
  </div>
</bdc-walk-popup>
